import { useNavigate, Link } from 'react-router-dom';
import { useTheme } from '../theme';
import { makeAuthStyles } from './authStyles';

// Placeholder. A real token-based reset flow (needs email on the account) will
// replace this later.
export default function ForgotPasswordPage() {
  const { colors } = useTheme();
  const S = makeAuthStyles(colors);
  const navigate = useNavigate();

  return (
    <div style={S.page}>
      <div style={S.card}>
        <h1 style={S.title}>Forgot password</h1>
        <p style={{ color: colors.text, fontSize: 14, lineHeight: 1.5, textAlign: 'center', margin: 0 }}>
          Password reset isn't available yet. Please contact the administrator to reset
          your password.
        </p>
        <button style={S.buttonAlt} type="button" onClick={() => navigate(-1)}>Back</button>
        <Link to="/login" style={S.link}>Back to sign in</Link>
      </div>
    </div>
  );
}
